<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppBox from '@/components/app/box.vue';
export default {
  components: { AppBox },
  props: {
    stationsAverageTimes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    stationTimeHeaders: {
      type: Array,
      default: () => [],
      required: true
    },
  },
};
</script>
<template>
  <app-box class="table-box-container">
    <v-row no-gutters class="height-full">
      <v-col cols="12" class="height-full relative">
        <div v-if="loading" class="loader-container">
          <span class="loader"></span>
        </div>
        <v-simple-table v-else height="100%" fixed-header class="table height-full">
          <template v-slot:default>
            <thead class="thead-element">
              <tr class="bg-white">
                <th class="pa-0">
                  <section>
                    <div class="table-seperator">
                      <div class="text-container">زمان ها</div>
                      <div class="text-seperator"></div>
                      <div class="text-container">پایگاه ها</div>
                    </div>
                  </section>
                </th>
                <th v-for="({ title, text }, index) in stationTimeHeaders" :key="index">
                  <v-tooltip :nudge-right="index === 0 ? 200 : 0" z-index="20000" top :value="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-col v-bind="attrs" v-on="on" class="px-2 max-width table-title-content self-center">
                        {{ title }}
                      </v-col>
                    </template>
                    <span>{{ text }}</span>
                  </v-tooltip>
                </th>
              </tr>
            </thead>
            <tbody v-if="!loading">
              <tr v-for="({ station, ...row }, index) in stationsAverageTimes" :key="index">
                <td class="text-center station-time-item">{{ station }}</td>
                <td v-for="({ value }, index) in stationTimeHeaders" :key="index" class="text-center station-time-item">
                  <v-row no-gutters class="gap-1 items-center">
                    <v-row no-gutters class="items-center justify-end">
                      <div>
                        {{ row?.[value]?.time }}
                      </div>
                      <v-icon v-if="row?.[value]?.fence" color="#212121">
                        mdi-account mdi-20px
                      </v-icon>
                    </v-row>
                    <div v-if="row?.[value]?.fence" class="seperator"></div>
                    <v-row v-if="row?.[value]?.fence" no-gutters class="items-center justify-start primary-color">
                      <div>
                        {{ row?.[value]?.fence }}
                      </div>
                      <v-icon dark color="darkColor">mdi-vector-square mdi-20px</v-icon>
                    </v-row>
                  </v-row>
                </td>
                <!-- <td class="text-center station-time-item">{{firstTime}}</td>
                <td class="text-center station-time-item">
                  {{secondTime}}
                </td>
                <td class="text-center station-time-item">{{thirdTime}}</td>
                <td class="text-center station-time-item">
                  {{fourthTime}}
                </td>
                <td class="text-center station-time-item">{{FifthTime}}</td>
                <td class="text-center station-time-item">{{sixthTime}}</td>
                <td class="text-center station-time-item">{{sevenTime}}</td>
                <td class="text-center station-time-item">
                  {{eightthTime}}
                </td>
                <td class="text-center station-time-item">{{ninthTime}}</td> -->
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </app-box>
</template>
<style lang="scss">
.table-box-container {
  height: 10px;
  flex-grow: 1;
}

.seperator {
  height: 20px;
  width: 2px;
  background-color: #212121;
}

.table {
  .thead-element {
    position: sticky;
    top: 0;
    left: 0;
  }

  table {
    height: 100%;
  }
}
</style>
<style scoped lang="scss">
.loader-container {
  & {
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    width: fit-content;
    height: fit-content;
  }

  .loader {
    width: 60px;
    height: 60px;
    border: 5px solid var(--dark-color);
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
}

.each_time_title {
  font-weight: 700;
}

.each_time_text {
  font-weight: 600;
  font-size: 1rem;
}

.table-seperator {
  position: relative;
  padding: 0.2rem;
  background: linear-gradient(to top left,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) calc(50% - 0.8px),
      rgb(255, 255, 255) 50%,
      rgba(0, 0, 0, 0) calc(50% + 0.8px),
      rgba(0, 0, 0, 0) 100%),
    var(--light-color);
  border-top-right-radius: 0.5rem;

  .text-container {
    color: white;

    &:first-child {
      padding-left: 10%;
      text-align: left;
    }

    &:last-child {
      padding-right: 5%;
    }
  }
}

.table-title-content {
  font-weight: 700;
  text-align: center;
}

.station-time-item {
  border-bottom: 0 !important;
  background-color: var(--background-color);

  &:first-of-type {
    background-color: white;
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
